import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { ShoppingCartOutlined } from "@material-ui/icons";
import { Badge } from "@material-ui/core";
import { useSelector } from "react-redux";
// import { selectQuantity } from "../redux/cartRedux";

const Container = styled.nav`
  background-color: black;
  color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  height: 60px;

  a {
    color: white;
    text-decoration: none;
  }
`;
const Account = styled.ul`
  display: flex;
  align-items: center;
  list-style: none;

  li {
    padding: 5px 20px;

    @media only screen and (max-width: 768px) {
      padding: 5px;
    }

    a {
      color: inherit;
      text-decoration: none;
    }
  }
`;

export default function Nav() {
  const quantity = useSelector(state => state.cart.count);

  return (
    <Container>
      <Link to="/products">
        <span>Shop.</span>
      </Link>

      <Account>
        <li>
          <Link to="/register">REGISTER</Link>
        </li>
        <li>
          <Link to="/login">LOG IN</Link>
        </li>
        <li>
          <Link to="/cart">
            <Badge
              badgeContent={quantity}
              overlap="rectangular"
              color="primary"
            >
              <ShoppingCartOutlined />
            </Badge>
          </Link>
        </li>
      </Account>
    </Container>
  );
}
